import axios from "axios";
import { config } from '../config.env'

const platform = config.PLATFORM;
const origin = config.ORIGIN || window.location.origin;
const endpoint = config.ENDPOINT;

export function getQrCode() {

    //const url = new URL(origin);
    //const hostname = url.hostname; // To extract only hostname, removing "https://" etc.
    console.log(config);
    return new Promise(resolve => {
        const url = `${endpoint}/thaid/generateURL`;
        const header = {
            'Content-Type': 'application/json',
        };
        const body = {
            app_id: config.THAID_APP_ID,
            app_secret: config.THAID_APP_SECRET,
            platform: config.THAID_APP_PLATFORM,
            url_redirect: `${origin}/loginThaID`
        };

        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((err) => {
            resolve(false)
        });
    });
}

export function information(pid) {

    return new Promise(resolve => {
        const url = `${endpoint}/thaid/information`;
        const header = {
            "Content-Type": "application/json",
        };
        const body = {
            app_id: config.THAID_APP_ID,
            app_secret: config.THAID_APP_SECRET,
            platform: config.THAID_APP_PLATFORM,
            pid: pid
        };

        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function register(profile) {

    if (!profile)
        return false;

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/authentication/register/thaid`;
        const header = {
            "Content-Type": "application/json",
            Platform: platform,
        };
        const body = {
            pid: profile.pid.trim(),
            thaid_uid: profile.thaid_uid.trim(),
            platform: platform,
            user_type: profile.user_type.trim(),
            allow_policy: profile.allow_policy,
            allow_term_of_use: profile.allow_term_of_use,
            hospital_code: profile.hospital_code?.trim() || undefined,
            pname: profile.pname?.trim() || undefined,
            fname: profile.fname?.trim() || undefined,
            lname: profile.lname?.trim() || undefined,
            phone: profile.phone?.trim() || undefined,
            email: profile.email?.trim().toLowerCase() || undefined,
        };

        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function buildThaiDUid(pid) {
  return `${pid}@bora.dopa.go.th`;
}

export async function login(pid, thaidUid) {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/authentication/login/thaid`;
        const header = {
            "Content-Type": "application/json",
        };
        const body = {
            pid: pid,
            thaid_uid: thaidUid,
            platform: platform,
        };

        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function profile() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/authentication/profile`;
        const header = {
            'Platform': platform,
            'Content-Type': "application/json",
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function refreshToken() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/authentication/login`;
        const body = {
            'refresh_token': localStorage.getItem('refresh_token'),
        };
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        
        axios.put(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function logout() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/authentication/logout`;
        const body = {
            'refresh_token': localStorage.getItem('refresh_token'),
        };
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        
        axios.delete(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}
